import React, { ReactNode } from 'react';
import { useCustomerCompanyCarbonManager } from '../../contexts/remote-data/useCustomerCompanyCarbonManager';
import { useCurrentCustomerId } from '../../contexts/remote-data/useCustomerId';
import { WordMark } from '../branding/WordMark';
import { ImageWithFallback } from '../ImageWithFallback';

export interface LogoHeaderBaseProps {
  rightIcon?: ReactNode;
  logoSize?: 'small' | 'large';
  className?: string;
  logo: ReactNode;
}

export const LogoHeaderBase: React.FC<LogoHeaderBaseProps> = ({
  children,
  rightIcon,
  className = '',
  logo,
  logoSize = 'small',
}) => {
  return (
    <div className={`m-0 p-5 ${className} d-flex gap-2 flex-column`}>
      <div className="d-flex flex-wrap justify-content-between">
        <div
          style={{
            maxWidth: logoSize === 'small' ? '200px' : '400px',
            minWidth: '50px',
            flexShrink: 1,
          }}
        >
          {logo}
        </div>
        <div>{rightIcon}</div>
      </div>
      {children}
    </div>
  );
};

export interface LogoHeaderProps {
  rightIcon?: ReactNode;
  logoSize?: 'small' | 'large';
  variant?: 'primary' | 'dark';
}

export const LogoHeader: React.FC<LogoHeaderProps> = ({ variant = 'primary', ...rest }) => {
  return (
    <LogoHeaderBase
      className={variant === 'primary' ? 'bg-primary text-dark' : 'bg-dark text-light'}
      logo={
        <WordMark
          variant={variant === 'dark' ? 'light' : 'dark'}
          style={{
            marginLeft: '-5%',
            width: '100%',
          }}
        />
      }
      {...rest}
    />
  );
};

export const LogoHeaderCarbonManager: React.FC<{
  rightIcon?: ReactNode;
  logoSize?: 'small' | 'large';
}> = ({ ...rest }) => {
  const customerId = useCurrentCustomerId();
  const { carbonManager } = useCustomerCompanyCarbonManager(customerId);

  return (
    <LogoHeaderBase
      className="bg-company-header text-company-header-text"
      logo={
        <ImageWithFallback
          src={carbonManager?.properties?.branding?.logo_url}
          alt="Company Logo"
          fallback={<></>}
        />
      }
      {...rest}
    />
  );
};

export default LogoHeader;
